import { createGlobalStyle } from 'styled-components'
import { normalize } from './normalize'
import { fonts } from './fonts'

export enum Breakpoints {
	sm = '360px',
	ms = '768px',
	lx = '1024px',
	xl = '1280px',
}

export const GlobalStyle = createGlobalStyle`
  ${normalize}
	${fonts}
`
